import { X } from 'lucide-react'
import { cn } from '@/modules/shared/lib/utils'
import { useToastStore, type Toast as ToastData } from '../stores/toastStore'

const TYPE_STYLES: Record<ToastData['type'], string> = {
  info: 'border-[var(--y-accent)]',
  success: 'border-[var(--y-success)]',
  error: 'border-[var(--y-error)]',
}

function ToastItem({ toast }: { toast: ToastData }) {
  const removeToast = useToastStore((s) => s.removeToast)

  return (
    <div
      className={cn(
        'flex items-center gap-3 px-4 py-3 rounded-2xl',
        'bg-[var(--y-surface-primary)] border',
        'animate-in slide-in-from-bottom-4 fade-in duration-300',
        TYPE_STYLES[toast.type],
      )}
      style={{ boxShadow: 'var(--y-shadow-fab, 0 4px 24px rgba(0,0,0,0.15))' }}
    >
      <p className="flex-1 text-sm text-[var(--y-text-primary)]">{toast.message}</p>
      {toast.action && (
        <button
          onClick={() => {
            toast.action!.onClick()
            removeToast(toast.id)
          }}
          className="px-3 py-1.5 rounded-lg text-xs font-semibold flex-shrink-0"
          style={{ background: 'var(--y-accent)', color: 'var(--y-accent-text)' }}
        >
          {toast.action.label}
        </button>
      )}
      <button
        onClick={() => removeToast(toast.id)}
        className="p-1 rounded-full text-[var(--y-text-tertiary)] hover:text-[var(--y-text-primary)] transition-colors flex-shrink-0"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  )
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[200] flex flex-col gap-2 w-[min(360px,calc(100vw-32px))]">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  )
}
